import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NssComponent } from './nss.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: NssComponent,
    data: {
      title: "NSS",
      breadcrumb: "NSS"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class NssRoutingModule { }